module.exports = __webpack_public_path__ + "static/img/banner01.1f04e69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner01.png
// module id = vh2T
// module chunks = 1